import { render, staticRenderFns } from "./DxDetailTabWorkers.vue?vue&type=template&id=1e7540c4&"
import script from "./DxDetailTabWorkers.vue?vue&type=script&lang=js&"
export * from "./DxDetailTabWorkers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports